// extracted by mini-css-extract-plugin
export var videoHero = "_dd-4";
export var videoHeroImage = "_dd-5";
export var videoHeroOverlay = "_dd-6";
export var videoHeroSubtitle = "_dd-8";
export var videoHeroText = "_dd-7";
export var videoLauncher = "_dd-0";
export var videoLauncherIcon = "_dd-1";
export var videoLauncherSubtitle = "_dd-3";
export var videoLauncherTitle = "_dd-2";
export var videoPlayer = "_dd-a";
export var videoPlayerWrap = "_dd-9";